import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Stack, { StackProps } from "@mui/material/Stack";
import { ReactNode } from "react";

type PrimaryAndSecondaryElementProps = {
  primary: ReactNode;
  secondary: ReactNode;
  shouldDimSecondary?: boolean;
} & StackProps;

export function PrimaryAndSecondaryElement({
  primary,
  secondary,
  shouldDimSecondary = true,
  ...stackProps
}: PrimaryAndSecondaryElementProps) {
  const theme = useTheme();
  return (
    <Stack direction="column" {...stackProps}>
      <Box sx={{ textWrap: "nowrap" }}>{primary}</Box>
      <Box
        sx={{
          opacity: shouldDimSecondary ? 0.6 : 1,
          fontSize: "16px",
          fontWeight: theme.custom.reservationSummaryFontWeight,
          textWrap: "nowrap",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {secondary}
      </Box>
    </Stack>
  );
}
